/** @format */

import {
	AppProductReviewState,
	ProductReviewAnalyticsService,
	selectHighlyRatedFeatures,
	selectProductReviewCount
} from '@product-reviews/data-access';
import { Component, computed, inject, input, output } from '@angular/core';

import { CommonModule } from '@angular/common';
import { HmfActionTextComponent } from '@dsg-tech/homefield-angular';
import { Store } from '@ngrx/store';
import { BreakPointNew } from '@shared/data-access/enums';
import { BreakpointsService } from '@shared/data-access/services';

@Component({
	selector: 'product-reviews-review-highly-rated-features',
	imports: [CommonModule, HmfActionTextComponent],
	templateUrl: './review-highly-rated-features.component.html',
	styleUrl: './review-highly-rated-features.component.scss'
})
export class ReviewHighlyRatedFeaturesComponent {
	private readonly breakpointsService = inject(BreakpointsService);
	private readonly store = inject(Store<AppProductReviewState>);
	private readonly analyticsService = inject(ProductReviewAnalyticsService);

	readonly open = output<boolean>();

	readonly template = input<'in-stock' | 'out-of-stock' | 'custom'>('in-stock');
	readonly isMobile = computed(() => this.breakpointsService.breakpoint() <= BreakPointNew.SMALL);

	highlyRatedForFeatures$ = this.store.select(selectHighlyRatedFeatures);
	reviewCount$ = this.store.select(selectProductReviewCount);

	openModal() {
		this.open.emit(true);
		this.trackHighlyRatedFilterOpen();
	}

	private trackHighlyRatedFilterOpen() {
		const payload = {
			event: 'RatingsAndReviewsInteraction',
			value: 'HighlyRatedFor',
			details: 'Open'
		};

		this.analyticsService.fireReviewAnalytics<{ [key: string]: string }>({
			name: 'multiUseAnalyticsEvent',
			payload
		});
	}
}
